<template>
	<div>
		<div class="xs-12 fs5 fw7 mb2">Policyholder</div>
		<case-form :schema="schemaPolicyholder" />
		<!-- Contact Person -->
		<div class="xs-12 fs5 fw7 mt6 mb2">Contact Person</div>
		<case-form :schema="schemaContactPerson" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "PJProposalPolicyholder",
	components: { CaseForm },

	computed: {
		schemaPolicyholder() {
			return [
				{
					label: "Select Policyholder",
					component: "entitySelect",
					bindTo: "case.holder",
					entity: "case.holder",
					props: {
						allowedEntityTypes: ["individual"]
					}
				},
				{
					label: "First Name in English",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "englishFirstName",
					props: {
						updateOptions: {
							component: "text"
						}
					}
				},
				{
					label: "Last Name in English",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "englishLastName",
					props: {
						updateOptions: {
							component: "text"
						}
					}
				},
				{
					label: "First Name in Chinese",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "chineseFirstName",
					props: {
						updateOptions: {
							component: "text"
						}
					}
				},
				{
					label: "Last Name in Chinese",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "chneseLastName",
					props: {
						updateOptions: {
							component: "text"
						}
					}
				},
				{
					label: "Date of Birth",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "dateOfBirth",
					props: {
						updateOptions: {
							component: "dateOfBirth"
						}
					}
				},
				{
					label: "Title",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "salutation",
					props: {
						updateOptions: {
							component: "select",
							props: {
								options: [
									{
										name: "Mr",
										value: "Mr"
									},
									{
										name: "Mrs",
										value: "Mrs"
									},
									{
										name: "Miss",
										value: "Miss"
									}
								]
							}
						}
					}
				},
				/*
				{
					label: "ID / Passport",
					component: "entityIdentity",
					entity: "case.holder",
					relation: "case.holder.identities",
					bindTo: "case.facts.holderIdentityId"
				},
				*/
				{
					label: "Address",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.holder.addresses",
					bindTo: "case.facts.holderAddressId"
				},
				{
					label: "Contact Number",
					component: "entityContact",
					entity: "case.holder",
					relation: "case.holder.contacts",
					bindTo: "case.facts.holderContactNumberId"
				},
				{
					label: "Fax Number",
					component: "entityContact",
					entity: "case.holder",
					relation: "case.holder.contacts",
					bindTo: "case.facts.holderFaxNumberId"
				},
				{
					label: "Nature of Business",
					component: "entityField",
					entity: "case.holder",
					fieldToUpdate: "natureOfBusiness",
					props: {
						updateOptions: {
							component: "select",
							props: {
								options: [
									{
										name: "Pawn Broker",
										value: "Pawn Broker"
									},
									{
										name: "Director",
										value: "Director"
									},
									{
										name: "Money Exchange",
										value: "Money Exchange"
									},
									{
										name: "Office",
										value: "Office"
									},
									{
										name: "Pawn Shop",
										value: "Pawn Shop"
									},
									{
										name: "Retail",
										value: "Retail"
									},
									{
										name: "Retail Shop",
										value: "Retail Shop"
									},
									{
										name: "Trading",
										value: "Trading"
									},
									{
										name: "Wholesale",
										value: "Wholesale"
									}
								]
							}
						}
					}
				},
				{
					label: "Territorial Limits",
					component: "text",
					bindTo: "case.facts.territorialLimits"
				},
				{
					label: "Underwriter Approval",
					component: "text",
					bindTo: "case.facts.underwriterApproval"
				}
			]
		},

		schemaContactPerson() {
			return [
				{
					label: "Name",
					component: "text",
					bindTo: "case.facts.contactPersonName"
				},
				{
					label: "Title",
					component: "select",
					bindTo: "case.facts.contactPersonTitle",
					props: {
						options: [
							{
								name: "Mr.",
								value: "Mr"
							},
							{
								name: "Mrs.",
								value: "Mrs"
							},
							{
								name: "Ms.",
								value: "Ms"
							},
							{
								name: "Miss",
								value: "Miss"
							},
							{
								name: "Dr.",
								value: "Dr"
							}
						]
					}
				},
				{
					label: "Email",
					component: "text",
					bindTo: "case.facts.contactPersonEmail"
				},
				{
					label: "Mobile",
					component: "text",
					bindTo: "case.facts.contactPersonMobile"
				},
				{
					label: "Tel",
					component: "text",
					bindTo: "case.facts.contactPersonTelephone"
				},
				{
					label: "Fax",
					component: "text",
					bindTo: "case.facts.contactPersonFax"
				}
			]
		}
	}
}
</script>
